let Detect = class {
    constructor(options) {
        this.url = options.url;
        this.defaultParams = options.defaultParams;
    }

    getList(filterSet) {
        let params = this.makeParams(filterSet);

        try {
            return this.url(params).then(res => res.Data.Result).then(res => {
                let list = [];
                let item = {};
                if(res.hasOwnProperty('List') && res.List.hasOwnProperty('Result')) {
                    list = res.List.Result;
                    for (let i = 0; i < list.length; i++) {
                        list[i].dr_status_select = list[i].dr_status;
                    }
                }
                if(res.hasOwnProperty('List') && res.List.hasOwnProperty('Item') && res.List.Item.length > 0) {
                    item = Object.assign({}, item, res.List.Item[0]);
                }
                if(res.hasOwnProperty('List') && res.List.hasOwnProperty('Detect')) {
                    item = Object.assign({}, item, res.List.Detect);
                }
                let total = 0;
                if(res.hasOwnProperty('Page')) {
                    total = res.Page.total;
                }
                return {
                    list: list,
                    item: item,
                    total: total
                }

            })
        }catch (e) {
            console.log(e);
        }
    }
    makeParams(filterSet) {
        let returnParams = JSON.parse(JSON.stringify(this.defaultParams));
        let filterList = Object.values(filterSet.filter);
        filterList.forEach(obj => {
            /*if(obj.hasOwnProperty('query')) {
                returnParams[obj.key] = obj.query;
            }else if(obj.hasOwnProperty('value')) {
                returnParams[obj.key] = obj.value;
            }else if(obj.hasOwnProperty('start') && obj.hasOwnProperty('end')) {
                returnParams[obj.key+'sd'] = obj.start;
                returnParams[obj.key+'ed'] = obj.end;
            }*/
            returnParams = this.setFilterParamValue(returnParams, obj);
        });
        if(filterSet.sort.hasOwnProperty('key') && filterSet.sort.hasOwnProperty('order')) {
            if(filterSet.sort.option.hasOwnProperty('keyName')) {
                returnParams[filterSet.sort.option.keyName] = filterSet.sort.key
            }else{
                returnParams.orderByType = filterSet.sort.key;
            }

            if(filterSet.sort.option.hasOwnProperty('orderName')) {
                returnParams[filterSet.sort.option.orderName] = filterSet.sort.order
            }else{
                returnParams.orderBySort = filterSet.sort.order;
            }


        }
        if(filterSet.page.hasOwnProperty('page')) {
            returnParams.page = filterSet.page.page;
        }
        if(filterSet.page.hasOwnProperty('size')) {
            returnParams.sp = filterSet.page.size;
        }
        return returnParams;
    };

    setFilterParamValue(params, obj) {
        if(obj.hasOwnProperty('query')) {
            params[obj.key] = obj.query;
        }else if(obj.hasOwnProperty('value')) {
            if(!obj.option || !obj.option[obj.value]) {
                params[obj.key] = obj.value;
            }else{
                params = Object.assign({}, params, obj.option[obj.value]);
            }


        }else if(obj.hasOwnProperty('start') && obj.hasOwnProperty('end')) {
            if(!obj.option.start) {
                params[obj.key+'sd'] = obj.start;
            }else{
                params[obj.option.start] = obj.start;
            }
            if(!obj.option.end) {
                params[obj.key+'ed'] = obj.end;
            }else{
                params[obj.option.end] = obj.end;
            }
        }else if(obj.hasOwnProperty('terms')) {
            for (let i = 0; i<obj.terms.length; i++) {
                params[`${obj.key}[${i}]`] = obj.terms[i];
            }
        }
        return params;
    };
}

export default Detect;
